import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionLineageCountsFragmentGql } from './VirtualConnectionLineageCountsFragmentGql';

export const VirtualConnectionLineageCountsFilteredByTableQueryGql: DocumentNode = gql`
query VirtualConnectionLineageCountsFilteredByTableQuery(
  $vizportalUrlId: String!,
  $selectedTableId: ID!
) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionLineageCountsFragment
    filteredTablesConnection: tablesConnection(filter: { id: $selectedTableId }) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
${VirtualConnectionLineageCountsFragmentGql}
`;
